//import { createPopper } from '@popperjs/core';
import tippy from 'tippy.js';
//import 'tippy.js/dist/tippy.css';

const createHTMLMapMarker = ({ OverlayView = google.maps.OverlayView,  ...args }) => {
    class HTMLMapMarker extends OverlayView {
        constructor() {
          super();
          this.latlng = args.latlng;
          this.boxContent = args.boxContent;
          this.html = args.html;
          this.setMap(args.map);
        }
      
        createDiv() {
            this.div = document.createElement('div');
            this.div.style.position = 'absolute';
            this.div.classList.add('custom-marker');
            if (this.html) {
                this.div.innerHTML = this.html;
            }

            var that = this;

            tippy(this.div, {
                content: this.boxContent,
                allowHTML: true,
                trigger: 'click',
                hideOnClick: true,
                interactive: true,
                maxWidth: 450,
                placement: 'bottom-start',
                onShow() {
                    that.disablePanningAndScrolling();
                },
                onHide() {
                    that.enablePanningAndScrolling();
                }
            });

            google.maps.event.addDomListener(this.div, 'click', event => {
                google.maps.event.trigger(this, 'click');
            });
        }

        enablePanningAndScrolling()
        {
            this.map.setOptions({
                zoomControl: true,
                gestureHandling: 'cooperative' // or 'cooperative'*
            });
        }

        disablePanningAndScrolling()
        {
            this.map.setOptions({
                zoomControl: false,
                gestureHandling: 'none'
            });
        }
      
        appendDivToOverlay() {
          const panes = this.getPanes();
          //panes.overlayLayer.appendChild(this.div);
          panes.overlayMouseTarget.appendChild(this.div)
        }
      
        positionDiv() {
          const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
          if (point) {
            this.div.style.left = `${point.x}px`;
            this.div.style.top = `${point.y}px`;
          }
        }
      
        draw() {
          if (!this.div) {
            this.createDiv();
            this.appendDivToOverlay();
          }
          this.positionDiv();
        }
      
        remove() {
          if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
          }
        }
      
        getPosition() {
          return this.latlng;
        }
      
        getDraggable() {
          return false;
        }
    }
  
    return new HTMLMapMarker();
};
  
export default createHTMLMapMarker;